import { IconBase } from './IconBase'

type IconChracters1Props = React.ComponentProps<'svg'>

export const IconChracters1 = ({ ...props }: IconChracters1Props) => {
  return (
    <IconBase width="1em" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="M2.75 18.25C2.75 15.627 4.877 13 7.5 13"
        stroke="#176758"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.5 9.25c0 2.623-2.238 4.75-5 4.75"
        stroke="#176758"
        strokeWidth="1.539"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.75 18.25v4M15.25 18.25v4"
        stroke="#176758"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.834 20H6.166C5.522 20 5 19.54 5 18.97V3.53c0-.57.522-1.03 1.167-1.03h11.666c.645 0 1.167.46 1.167 1.03v15.44c0 .57-.522 1.03-1.166 1.03Z"
        fill="url(#a)"
      />
      <path
        d="M16.889 11.5H7.111c-.337 0-.611-.258-.611-.577V4.577c0-.319.274-.577.611-.577h9.778c.337 0 .611.258.611.577v6.346c0 .319-.274.577-.611.577Z"
        fill="url(#b)"
      />
      <path
        d="M7 12.5h6a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1ZM17 13.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
        fill="#272727"
      />
      <path
        d="M10.25 16H9.5v-.75a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25V16h-.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.75v.75c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25V17h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25Z"
        fill="#FAC600"
      />
      <path d="M15.5 15.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="#C22300" />
      <path
        d="M9 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM15 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM12 8.71c-1.11 0-2-.46-2 0 0 .335.245.835.915 1.105.27-.195.655-.315 1.085-.315.43 0 .815.12 1.085.315.67-.27.915-.77.915-1.105 0-.46-.895 0-2 0Z"
        fill="#272727"
      />
      <path
        d="M13.085 9.815c-.28.115-.64.185-1.085.185-.445 0-.805-.07-1.085-.185.27-.195.655-.315 1.085-.315.43 0 .815.12 1.085.315Z"
        fill="#D75B60"
      />
      <path
        opacity=".05"
        d="M16.889 4c.337 0 .611.258.611.577v6.346c0 .319-.274.577-.611.577H7.111c-.337 0-.611-.258-.611-.577V4.577c0-.319.274-.577.611-.577h9.778Zm0-.5H7.111C6.499 3.5 6 3.983 6 4.577v6.346C6 11.517 6.498 12 7.111 12h9.778c.613 0 1.111-.483 1.111-1.077V4.577c0-.594-.498-1.077-1.111-1.077ZM9.25 15a.25.25 0 0 1 .25.25V16h.75a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25H9.5v.75a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25V17h-.75a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25h.75v-.75a.25.25 0 0 1 .25-.25h.5Zm0-.6h-.5a.851.851 0 0 0-.85.85v.15h-.15a.851.851 0 0 0-.85.85v.5c0 .468.381.85.85.85h.15v.15c0 .468.381.85.85.85h.5c.468 0 .85-.382.85-.85v-.15h.15c.469 0 .85-.382.85-.85v-.5a.851.851 0 0 0-.85-.85h-.15v-.15a.851.851 0 0 0-.85-.85ZM15.5 15.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Z"
        fill="#151515"
      />
      <path
        opacity=".05"
        d="M16.889 4c.337 0 .611.258.611.577v6.346c0 .319-.274.577-.611.577H7.111c-.337 0-.611-.258-.611-.577V4.577c0-.319.274-.577.611-.577h9.778Zm0-.25H7.111c-.475 0-.861.371-.861.827v6.346c0 .456.386.827.861.827h9.778c.475 0 .861-.371.861-.827V4.577c0-.456-.387-.827-.861-.827ZM9.25 15a.25.25 0 0 1 .25.25V16h.75a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25H9.5v.75a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25V17h-.75a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25h.75v-.75a.25.25 0 0 1 .25-.25h.5Zm0-.3h-.5a.55.55 0 0 0-.55.55v.45h-.45a.55.55 0 0 0-.55.55v.5c0 .303.247.55.55.55h.45v.45c0 .303.247.55.55.55h.5a.55.55 0 0 0 .55-.55v-.45h.45a.55.55 0 0 0 .55-.55v-.5a.55.55 0 0 0-.55-.55H9.8v-.45a.55.55 0 0 0-.55-.55ZM15.5 15.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-.25c-.689 0-1.25.561-1.25 1.25 0 .69.561 1.25 1.25 1.25s1.25-.56 1.25-1.25c0-.689-.561-1.25-1.25-1.25Z"
        fill="#151515"
      />
      <defs>
        <linearGradient
          id="a"
          x1="7.39"
          y1=".275"
          x2="10.505"
          y2="7.692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55C8AA" />
          <stop offset=".544" stopColor="#4CC0A6" />
          <stop offset="1" stopColor="#41B6A1" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="10.643"
          y1="1.72"
          x2="13.017"
          y2="12.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset=".228" stopColor="#EDEEEF" />
          <stop offset=".595" stopColor="#D6D9DB" />
          <stop offset="1" stopColor="#B4BBC0" />
        </linearGradient>
      </defs>
    </IconBase>
  )
}
